var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_71_18976)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 34,
    height: 32.4186,
    rx: 16.2093,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 12.5,
    width: 33,
    height: 31.4186,
    rx: 15.7093,
    stroke: "#C4C4C4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6524 24.6512H29.8617V34.9303C29.8617 35.3497 30.0283 35.7519 30.3248 36.0485C30.6214 36.345 31.0237 36.5116 31.4431 36.5116H39.35C39.7695 36.5116 40.1717 36.345 40.4683 36.0485C40.7648 35.7519 40.9314 35.3497 40.9314 34.9303V24.6512H30.6524ZM33.8152 34.1396H32.2338V27.0233H33.8152V34.1396ZM38.5593 34.1396H36.9779V27.0233H38.5593V34.1396ZM39.048 22.2791L37.7686 20.6977H33.0245L31.7451 22.2791H28.2803V23.8605H42.5128V22.2791H39.048Z",
    fill: "#1B1C1C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_71_18976",
    x: 0,
    y: 0,
    width: 70,
    height: 68.4186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_71_18976"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_71_18976",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.5d7a028ce3c8a20b7c667253677b1f2d.svg";
export { ForwardRef as ReactComponent };